import React from 'react';


export default function Help() {
    return (
        <div style={{padding: '30px'}}>
            <h1>Basic options</h1>
            <p>
                <strong>PDB code:</strong> Enter a PDB code or upload a file in the .pdb or .cif file format and click on UPLOAD.
            </p>
            <p>When the structure has been uploaded:</p>
            <p>
                <strong>Chain/Molecule 1:</strong> Select a chain for molecule 1 and optionally digit the start and end residue numbers to be analyzed within the given range; by default the whole chain will be considered.
            </p>
            <p>
                <strong>Chain/Molecule 2:</strong> Select a chain for molecule 2 and optionally digit the start and end residue numbers to be analyzed within the given range; by default the whole chain will be considered.
            </p>

            <h1>Advanced options (optional):</h1>
            <p>
                <strong>Project name:</strong> Optional. Any string can indentify your result. If you leave it blank, a default name will be used. Don't use white-space separated words.
            </p>
            <p>
                <strong>Email:</strong> Optional. If a valid e-mail address is provided, a link to a page on the server is e-mailed to the users, where they can access their results (which are also displayed online) for three months.
            </p>
            <p>
                <strong>Name Molecule 1: </strong> Optional. If a valid e-mail address is provided, a link to a page on the server is e-mailed to the users, where they can access their results (which are also displayed online) for three
                months.
            </p>
            <p>
                <strong>Name Molecule 2: </strong> Optional. Insert the name of the second interacting molecule of the complex (e.g. barstar). Otherwise, the generic name "Molecule 2" will be used.
            </p>
            <p>
                <strong>Cut-off:</strong> Threshold distance (in Å) to select interacting residues (default value: 5 Å).
            </p>
            <p>
                <strong>Set Interaction Parameters:</strong> : Default values are pre-set, and the minimum and maximum values are displayed. Users can select any values within the given ranges, according to their preference.
            </p>

            <h1>Results page</h1>
            <h2>Table of Atomic Interactions</h2>
            <p>
                <strong>Res Name 1:</strong> A one/two letter code for RNA/DNA and a three letter code for proteins and modified nucleotides/amino acids, followed by the residue number and the chain ID (after an underscore)), identifies an
                interacting residue belonging to Molecule 1.
            </p>
            <p>
                <strong>Res Name 2:</strong> A one/two letter code for RNA/DNA and a three letter code for proteins and modified nucleotides/amino acids, followed by the residue number and the chain ID (after an underscore), identifies an
                interacting residue belonging to Molecule 2.
            </p>
            <p>
                <strong>Interactions:</strong> Specifies the type(s) of atomic interactions given by a residue pair.
            </p>
            <p>
                <strong>ASA:</strong> Accessible Surface Area in Å<sup>2</sup>
            </p>
            <p>
                <strong>Buried area upon the complex formation (Å<sup>2</sup>):</strong> The buried ASA in the complex (free ASA minus complex ASA).
            </p>
            <p>
                <strong>Interface area (Å<sup>2</sup>): </strong> The area involved in the interaction (half of the buried area upon the complex formation).
            </p>
            <p>
                <strong>Buried area upon the complex formation (%): </strong> Percentage of buried ASA in the complex (buried area divided by free ASA, percentage)
            </p>
            <p>
                <strong>POLAR Buried area upon the complex formation(Å<sup>2</sup>):</strong> The polar buried ASA in the complex (free polar ASA minus complex polar ASA)
            </p>
            <p>
                <strong>Polar Interface area (Å<sup>2</sup>):</strong> The polar area involved in the interaction (half of the polar buried area upon the complex formation).
            </p>
            <p>
                <strong>POLAR Interface (%):</strong> P(%): Percentage of polar contribution to the interface (Polar buried ASA divided by total buried ASA, percentage).
            </p>
            <p>
                <strong>NON POLAR Buried area upon the complex formation (Å<sup>2</sup>):</strong> The non polar buried ASAin the complex (free non polar ASA minus complex non polar ASA).
            </p>
            <p>
                <strong>NON POLAR Interface area (<sup>2</sup>):</strong> The non-polar area involved in the interaction (half of the polar buried area upon the complex formation).
            </p>
            <p>
                <strong>NON POLAR Interface (%):</strong> The non-polar area involved in the interaction (half of the polar buried area upon the complex formation).
            </p>
            <p>
                <strong>ASA Table for Molecule 1: </strong> This section includes a list of molecule 1 residues at the interface, defined as those having an ASA (Accessible Surface Area) decreased by > 1.0 Å upon the complex formation. ASA
                values in the complex and in the isolated molecule (“free”), and the difference between them are reported for each residue. The percentage of buried surface upon complex formation is also reported.
            </p>
            <p>
                <strong>ASA Table for Molecule 2: </strong> This section includes a list of molecule 2 residues at the interface, defined as those having an ASA (Accessible Surface Area) decreased by > 1.0 Å upon the complex formation. ASA
                values in the complex and in the isolated molecule (“free”), and the difference between them are reported for each residue. The percentage of buried surface upon complex formation is also reported.
            </p>
        </div>
    )
}